import {memo} from 'react';

import type {SVGProps} from 'react';

export const KycIcon = memo(function KycIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M19.167 13.1297V14.206C19.167 14.8747 18.6249 15.4168 17.9566 15.4168H5.37741C4.70908 15.4168 4.16699 14.8747 4.16699 14.2064V10.0002V7.8335V5.79391C4.16699 5.12558 4.70908 4.5835 5.37741 4.5835H17.9562C18.6249 4.5835 19.167 5.12558 19.167 5.79391V10.4014V13.1297Z"
          fill="var(--icon-fill-green)"
        />
        <path
          d="M7.53613 2.7085H16.4582C17.1665 2.7085 17.7082 3.25016 17.7082 3.9585V8.75016"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4587 13.9585H3.54199C2.83366 13.9585 2.29199 13.4168 2.29199 12.7085V8.3335V6.0835V3.9585C2.29199 3.25016 2.83366 2.7085 3.54199 2.7085H4.37533"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 17.2915H12.1012"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.70801 13.9585V17.2918"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.208 14.9583L15.1663 15.9167L17.1663 13.875"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5459 18.8623C12.7784 18.4657 11.458 16.8869 11.458 14.9998C11.458 12.8136 13.2301 11.0415 15.4163 11.0415C17.6026 11.0415 19.3747 12.8136 19.3747 14.9998C19.3747 15.9482 19.0413 16.8186 18.4851 17.5003"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66658 8.17446C7.40848 8.17446 8.00991 7.57303 8.00991 6.83113C8.00991 6.08922 7.40848 5.48779 6.66658 5.48779C5.92467 5.48779 5.32324 6.08922 5.32324 6.83113C5.32324 7.57303 5.92467 8.17446 6.66658 8.17446Z"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeMiterlimit={5}
        />
        <path
          d="M4.59625 10.4117C4.45583 10.2267 4.375 10.008 4.375 9.75589C4.375 9.18964 4.83417 8.73047 5.40042 8.73047H7.9325C8.49875 8.73047 8.95792 9.18964 8.95792 9.75589C8.95792 10.0642 8.83667 10.3221 8.63417 10.5305"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M6.55992 11.1771C7.74034 11.2076 8.95826 10.7338 8.95826 9.75589C8.95826 9.18964 8.49909 8.73047 7.93284 8.73047H6.38867"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M10.625 6.0415H15.625"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.625 8.5415H12.8963"
          stroke="var(--icon-stroke-green)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
